export default __webpack_public_path__ + "static/25-8da650811bb89df0404bb0a34888d87c.jpg";